/*
 * @Description:
 * @Date: 2023-01-04 14:21:05
 */

export default {
  namespaced: true,
  state: {
    payType: 0 // 0初始值 1线上支付 2线下支付
  },
  mutations: {
    SET_PAYTYPE: (state, payload) => {
      state.payType = payload;
    }
  }
};
